export enum PostMessageEvents {
  ArticleCompleted = 'readArticle',
  IframeMounted = 'isMounted',
  CloseIframe = 'closeWebView',
  QuestTaskClick = 'questTaskClick',
  OpenRelatedArticle = 'openRelatedArticle',
}
